export default __webpack_public_path__ + "static/media/Pattern9.37f4ca49.png";